import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
// import createMutationsSharer from 'vuex-shared-mutations';

import app from './modules/app';
import auth from './modules/auth';
import company from './modules/company';
import biller from './modules/biller';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

/**
 * Core Vue Store for the application
 */
const CoreStore = new Vuex.Store({
  modules: {
    app,
    auth,
    company,
    biller,
  },
  strict: debug,
  plugins: [
    createPersistedState({
      paths: [
        'app',
        'auth',
        'company',
        'biller',
      ],
    }),
    /* createMutationsSharer({
      predicate(mutation) {
        // braadcast mutation's state to all tabs/windows
        // check if route changed is the logout one or not
        const mutationType = mutation.type.split('.');
        if (mutationType.length === 0) return false;

        const allowList = [
          app.APP_MODE_SET,
          company.GET_COMPANY_LIST_SUCCESS,
          company.GET_COMPANY_PROFILE_LIST_SUCCESS,
          company.GET_COMPANY_ADMIN_LIST_SUCCESS,
          company.GET_ADMIN_USER_LIST_SUCCESS,
        ];
        // return mutation.type !== 'route/ROUTE_CHANGED';
        return ['auth'].indexOf(mutationType[0]) !== -1 ||
          allowList.indexOf(mutation.type) !== -1;
      },
    }), */
  ],
});

export default CoreStore;



// WEBPACK FOOTER //
// ./src/store/index.js